// extracted by mini-css-extract-plugin
module.exports = {"contactDetailsTitle":"_1fhr5 _1R_Wx","contactDetailsBody":"Akuoi"};